/**
 * availableQuantity returns the atp (available-to-purchase) quantity.
 * @param {import('./').Product} product
 * @returns {number}
 */
function availableQuantity(product) {
  if (product.inventoryProperties) {
    return product.inventoryProperties.backOrdered ? product.inventoryProperties.backOrderedQty : product.inventoryProperties.atpQty;
  }

  if (product.childSkus && product.childSkus.length > 0) {
    const quantities = product.childSkus
      .filter(cs => cs.inventory !== undefined)
      .map(cs => cs.inventory.backOrdered ? cs.inventory.backOrderedQty : cs.inventory.atpQty);

    return Math.min(...quantities);
  }

  return 0;
}

module.exports = availableQuantity;
